<input
  type="text"
  class="calio-tel-input"
  [ngClass]="cssClass"
  [attr.id]="name"
  [attr.name]="name"
  [name]="name"
  [formControl]="telInputControl"
  (countrychange)="i18nizePhoneNumber()"
  (click)="onClick()"
  (blur)="onBlur()"
  #intlTelInput
  [attr.aria-label]="'Phone number'"
  [attr.aria-required]="required"
  [attr.aria-invalid]="telInputControl.invalid && telInputControl.touched"
  [attr.aria-autocomplete]="'tel'"
  [attr.inputmode]="'tel'"
/>
